// import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
// import { Link } from 'react-router-dom';

const TopInstructorsOne = ({ title = "Top Farms" }) => {
    // Sample data for farms, reviews, and ratings
    const farmsData = [
        { farmName: "Green Valley Farm", reviews: 25, rating: 5 },
        { farmName: "Sunny Acres Farm", reviews: 20, rating: 4 },
        { farmName: "Golden Harvest Farm", reviews: 18, rating: 4 },
        { farmName: "Blue Sky Farm", reviews: 15, rating: 3 },
        { farmName: "Happy Cow Farm", reviews: 12, rating: 3 },
        { farmName: "Organic Oasis Farm", reviews: 10, rating: 2 },
    ];

    return (
        <div className="col-xxl-6 col-md-6">
            <div className="card">
                <div className="card-header">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg mb-0">{title}</h6>
                        {/* Uncomment if you want to add a "View All" link */}
                        {/* <Link
                            to="#"
                            className="text-primary-600 hover-text-primary d-flex align-items-center gap-1"
                        >
                            View All
                            <Icon
                                icon="solar:alt-arrow-right-linear"
                                className="icon"
                            />
                        </Link> */}
                    </div>
                </div>
                <div className="card-body">
                    {farmsData.map((farm, index) => (
                        <div key={index} className="d-flex align-items-center justify-content-between gap-3 mb-24">
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1">
                                    <h6 className="text-md mb-0 fw-medium">{farm.farmName}</h6>
                                </div>
                            </div>
                            <div>
                                {/* Display rating stars */}
                                <div className="d-flex align-items-center gap-6 mb-1">
                                    {[...Array(5)].map((_, i) => (
                                        <span
                                            key={i}
                                            className={`text-lg ${i < farm.rating ? 'text-warning-600' : 'text-secondary-light'
                                                } d-flex line-height-1`}
                                        >
                                            <i className="ri-star-fill" />
                                        </span>
                                    ))}
                                </div>
                                <span className="text-primary-light text-sm d-block text-end">
                                    {farm.reviews} Reviews
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TopInstructorsOne;